import React, { useState } from 'react';
import './room3.css';

const CORRECT_ORDER = ['audience', 'dancer', 'host'];

const Music = ({ onClose, onSolve }) => {
  const [slots, setSlots] = useState([null, null, null]);
  const [selectedMask, setSelectedMask] = useState(null);
  const [error, setError] = useState(false);
  const [solved, setSolved] = useState(false);

  const masks = [
    {
      id: 'audience',
      name: 'Audience Mask',
    },
    {
      id: 'dancer',
      name: 'Dancer Mask',

    },
    {
      id: 'host',
      name: 'Host Mask',
 
    }
  ];

  const placeMask = (index) => {
    if (!selectedMask) return;

    const updated = [...slots];
    updated[index] = selectedMask;
    setSlots(updated);
    setSelectedMask(null);
  };

  const checkSolution = () => {
    const answer = slots.map(mask => mask?.id);

    const correct =
      JSON.stringify(answer) === JSON.stringify(CORRECT_ORDER);

    if (correct) {
      setSolved(true);

      setTimeout(() => {
        onSolve();
      }, 2000);
    } else {
      setError(true);
      setTimeout(() => setError(false), 800);
    }
  };

  return (
    <div className="puzzleoverlay" onClick={onClose}>
      <div
        className={`puzzlemodal musicmodal ${
          error ? 'puzzleshake' : ''
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <button className="puzzleclose" onClick={onClose}>
          ✕
        </button>

        <h2 className="puzzletitle">
          THE FORGOTTEN PERFORMANCE
        </h2>

        <p className="puzzlesubtitle">
          A faded note rests beside the music box...
        </p>

        <div className="storynote">
          <p className='storynotetextt'>"The audience arrived first."</p>
          <p className='storynotetextt'>"The dancer performed second."</p>
          <p className='storynotetextt'>"The host took the final bow."</p>
        </div>

        <div className="maskinventory">
          {masks.map((mask) => (
            <button
              key={mask.id}
              className={`maskbtn ${
                selectedMask?.id === mask.id ? 'selected' : ''
              }`}
              onClick={() => setSelectedMask(mask)}
            >
              <div>{mask.icon}</div>
              <span className='placemasktext'>{mask.name}</span>
            </button>
          ))}
        </div>

        <div className="maskslots">
          {slots.map((mask, index) => (
            <div
              key={index}
              className="maskslot"
              onClick={() => placeMask(index)}
            >
              {mask ? (
                <>
                  <div className="sloticon">
                    {mask.icon}
                  </div>
                  <span className='placemasktext'>{mask.name}</span>
                </>
              ) : (
                <span className='placemasktext'>Place Mask</span>
              )}
            </div>
          ))}
        </div>

        {!solved && (
          <button
            className="puzzlesubmit"
            onClick={checkSolution}
          >
            START PERFORMANCE
          </button>
        )}

        {solved && (
          <div className="successmessage">
            <h3>♪ The music box begins to play...</h3>
            <p>
              The ballerina slowly turns and a hidden
              compartment opens.
            </p>
          </div>
        )}

        {error && (
          <p className="puzzleerror">
            Nothing happens. The order feels wrong.
          </p>
        )}
      </div>
    </div>
  );
};

export default Music;